import { __extends, __spreadArray, __assign } from 'tslib';
import React__default from 'react';
import clsx from 'clsx';
import { IconGridDots } from '@tabler/icons';
import { Icon } from '../Icon/Icon.component.js';
import ButtonBase from '../ButtonBase/ButtonBase.component.js';
import { propTypes, defaultProps } from './LeftNavAppMenu.types.js';
import styles from './LeftNavAppMenu.module.scss.js';

var NavLink = /** @class */ (function (_super) {
    __extends(NavLink, _super);
    function NavLink() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClick = function (event) {
            event.preventDefault();
            _this.props.onClick(_this.props.link);
        };
        return _this;
    }
    NavLink.prototype.render = function () {
        return (React__default.createElement("button", { className: this.props.className, onClick: this.onClick }, this.props.children));
    };
    NavLink.displayName = 'NavLink';
    return NavLink;
}(React__default.Component));
/**
 * The application left nav slide out menu
 *
 * This component renders the navigation as a visible hover to open menu on
 * desktop, and as an off-canvas menu on mobile.
 */
var LeftNavAppMenu = /** @class */ (function (_super) {
    __extends(LeftNavAppMenu, _super);
    function LeftNavAppMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            selectedNavId: null,
            hover: false,
        };
        _this.onSelectLink = function (link) {
            _this.setState(function (_a) {
                var selectedNavId = _a.selectedNavId;
                return ({
                    selectedNavId: selectedNavId === link.id ? null : link.id,
                });
            });
            _this.props.onSelectLink(link);
        };
        _this.renderIcon = function (link) {
            return typeof link.icon === 'string' ? (React__default.createElement(Icon, { name: link.selectedIcon && link.isActive
                    ? link.selectedIcon
                    : link.icon, alt: link.icon, size: 24 })) : (link.icon);
        };
        _this.getLinkClassName = function (link, className) {
            var additionalClassNames = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                additionalClassNames[_i - 2] = arguments[_i];
            }
            return clsx.apply(void 0, __spreadArray([styles[className],
                link.isActive && styles[className + "___active"]], additionalClassNames, false));
        };
        _this.getIconName = function (link) {
            if (link.isActive || _this.state.selectedNavId === link.id) {
                return 'ChevronUpIcon';
            }
            return 'ChevronDownIcon';
        };
        _this.renderLink = function (link) { return (React__default.createElement(NavLink, { className: _this.getLinkClassName(link, 'NavLink', link.className), link: link, onClick: _this.onSelectLink },
            React__default.createElement("div", { className: styles.NavLink_icon }, _this.renderIcon(link)),
            React__default.createElement("span", { className: styles.NavLink_text }, link.displayName),
            !!link.subLinks.length && (React__default.createElement(Icon, { className: styles.NavLink_arrowIcon, name: _this.getIconName(link), alt: "link arrow", size: 24 })))); };
        _this.renderSubLink = function (subLink) { return (React__default.createElement("li", { className: styles.SubLinkWrapper, key: subLink.id },
            React__default.createElement("div", { className: _this.getLinkClassName(subLink, 'SubLinkContainer', subLink.className) },
                React__default.createElement(NavLink, { className: _this.getLinkClassName(subLink, 'SubNavLink', subLink.className, styles.SubNavLink), link: subLink, onClick: _this.onSelectLink }, subLink.displayName)))); };
        _this.renderSubLinkWrapper = function (link) {
            if (!link.subLinks.length) {
                return null;
            }
            var selectedNavId = _this.state.selectedNavId;
            var className = clsx(styles.VerticalSubNav, (link.isActive || link.id === selectedNavId) &&
                styles.VerticalSubNav___active);
            return (React__default.createElement("ul", { className: className }, link.subLinks.map(function (subLink) {
                return _this.renderSubLink(subLink);
            })));
        };
        _this.setHover = function () {
            _this.setState({
                hover: true,
            });
        };
        _this.setUnHover = function () {
            _this.setState({
                hover: false,
            });
        };
        return _this;
    }
    LeftNavAppMenu.prototype.render = function () {
        var _this = this;
        var _a = this.props, isOpen = _a.isOpen, onClose = _a.onClose, applicationName = _a.applicationName, applicationLinks = _a.applicationLinks, className = _a.className, withHeader = _a.withHeader;
        var leftNavMenuClass = clsx(className, styles.LeftNavMenu, isOpen && styles.LeftNavMenu___offcanvas, withHeader && styles.LeftNavMenu___withHeader, this.state.hover && styles.LeftNavMenu_hover);
        return (React__default.createElement(React__default.Fragment, null,
            React__default.createElement("div", { onClick: onClose, className: clsx(isOpen && styles.Overlay) }),
            React__default.createElement("div", { className: leftNavMenuClass, onMouseEnter: this.setHover, onMouseLeave: this.setUnHover, "data-testid": this.props['data-testid'] },
                React__default.createElement("div", { className: styles.LeftNavMenu_header },
                    React__default.createElement("div", { className: styles.HeaderContents },
                        React__default.createElement(ButtonBase, { className: styles.HeaderContents_icon, type: "button", onClick: this.props.onOpenVerticalsMenu, title: "AppsIcon" },
                            React__default.createElement(IconGridDots, { size: 22 })),
                        React__default.createElement("span", { className: styles.HeaderContents_text }, applicationName))),
                React__default.createElement("nav", { className: styles.LeftNavMenu_container },
                    React__default.createElement("ul", { className: styles.VerticalNav }, applicationLinks.map(function (link) { return (React__default.createElement("li", { key: link.id, className: styles.VerticalNav_link },
                        React__default.createElement("div", { className: _this.getLinkClassName(link, 'LinkWrapper') },
                            _this.renderLink(link),
                            _this.renderSubLinkWrapper(link)))); }))))));
    };
    LeftNavAppMenu.displayName = 'LeftNavAppMenu';
    LeftNavAppMenu.propTypes = propTypes;
    LeftNavAppMenu.defaultProps = __assign({}, defaultProps);
    return LeftNavAppMenu;
}(React__default.Component));

export { LeftNavAppMenu as default };
